module.exports = __webpack_public_path__ + "assets/img/video.b8d24350.png";